import styles from 'vet-bones/styles/colors.scss';

export const colors = {
  connected: styles['sd-color-green'],
  darkIcon: styles['sd-color-black'],
  queryBuilderGrayId: 'sd-qb-gray',
};
